import getVisibleColumnIndexByField from "../helpers/getVisibleColumnIndexByField";
//----------------
// is slot column
//----------------
export default function isSlotColumn(hover_col, headings) {
  //-------------------------------------
  // locate ca1 (first slot) in headings
  //-------------------------------------
  let col_idx = getVisibleColumnIndexByField(headings, "ca1");
  //---------------------
  // check col threshold
  //---------------------
  if (hover_col >= col_idx) {
    return true;
  } else {
    return false;
  }
}
